import { MoreVert } from "@mui/icons-material";
import { Button, Checkbox, InputLabel, TextField } from "@mui/material";
import { useAppContext } from "contexts";
import { useFormik } from "formik";
import { db, useClickArea } from "hooks";
import React from "react";
import { useRef } from "react";
import { useState } from "react";
import PhoneInput from "react-phone-number-input";
import Swal from "sweetalert2";
import * as Yup from "yup";

const AddressCard = (props) => {
  const [editAddress, setEditAddress] = useState(false);
  const [showEditSection, setShowEditSection] = useState(false);
  const editAddressRef = useRef(null);
  const [addressType, setAddressType] = useState(props?.address?.addressType);

  const { user } = useAppContext();

  //   console.log(props?.address);

  useClickArea(editAddressRef, () => {
    setEditAddress(false);
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: props?.address?.firstName,
      lastName: props?.address?.lastName,
      contactNo: props?.address?.contactNo,
      address: props?.address?.address,
      city: props?.address?.city,
      landmark: props?.address?.landmark,
      country: props?.address?.country,
      postalCode: props?.address?.postalCode,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string(),
      contactNo: Yup.string().required("Contact number is required"),
      address: Yup.string().required("Address is required"),
      city: Yup.string().required("City is required"),
      landmark: Yup.string(),
      country: Yup.string().required("Country is required"),
      postalCode: Yup.string().required("Postal code is required"),
    }),
    onSubmit: async (values, submitProps) => {
      try {
        // console.log(values);
        const address = {
          firstName: values?.firstName,
          lastName: values?.lastName,
          address: values?.address,
          landmark: values?.landmark,
          city: values?.city,
          country: values?.country,
          postalCode: values?.postalCode,
          addressType: addressType,
          default: false,
          contactNo: values?.contactNo,
        };
        await db.updateDb(
          "users/" + user?.uid + "/address/" + props?.address?.id,
          address
        );
        Swal.fire({
          title: "Success",
          text: "Address updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        setShowEditSection(false);
        submitProps.resetForm();
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    },
  });

  //   console.log(formik.values?.contactNo);

  const handleDeleteAddress = async () => {
    try {
      await db.delateData(
        "users/" + user?.uid + "/address/" + props?.address?.id
      );

      Swal.fire({
        title: "Success",
        text: "Address deleted successfully",
        icon: "success",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <div className="saved-address-card flex-column  gap-1">
      {/* {console.log(address)} */}
      {showEditSection ? (
        <form
          onSubmit={formik.handleSubmit}
          className="user-personal-update-form flex-column gap-1"
        >
          <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
            <span className="flex-column gap-1">
              <InputLabel>First Name</InputLabel>
              <TextField
                placeholder="e.g - Sahrukh "
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstName && formik.errors.firstName
                    ? true
                    : false
                }
                helperText={
                  formik.touched.firstName && formik.errors.firstName
                    ? formik.errors.firstName
                    : null
                }
              />
            </span>
            <span className="flex-column gap-1">
              <InputLabel>Last Name</InputLabel>
              <TextField
                placeholder="e.g - Khan "
                name="lastName"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                error={
                  formik.touched.lastName && formik.errors.lastName
                    ? true
                    : false
                }
                helperText={
                  formik.touched.lastName && formik.errors.lastName
                    ? formik.errors.lastName
                    : null
                }
              />
            </span>
          </span>
          <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
            <span className=" user-personal-update-form-dob  flex-column gap-1">
              <InputLabel>Postal Code</InputLabel>

              <TextField
                type={"number"}
                placeholder="e.g - 123456 "
                name="postalCode"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.postalCode}
                error={
                  formik.touched.postalCode && formik.errors.postalCode
                    ? true
                    : false
                }
                helperText={
                  formik.touched.postalCode && formik.errors.postalCode
                    ? formik.errors.postalCode
                    : null
                }
              />
            </span>
            <span className="flex-column gap-1">
              <InputLabel>Contact No</InputLabel>
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                name="contactNo"
                className="w-100 country-phone-input-address flex-row align-items-center "
                placeholder="e.g - 1234567890 "
                value={formik.values.contactNo}
                onChange={(value) => {
                  formik.setFieldValue("contactNo", value);
                }}
                onBlur={(value) => {
                  formik.handleBlur("contactNo");
                }}
                defaultCountry="IN"
              />
            </span>
          </span>
          <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
            <span className="flex-column gap-1">
              <InputLabel>Address</InputLabel>
              <TextField
                placeholder="e.g - 123, Main Street, Riyadh  "
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.address && formik.errors.address ? true : false
                }
                helperText={
                  formik.touched.address && formik.errors.address
                    ? formik.errors.address
                    : null
                }
              />
            </span>
            <span className="flex-column gap-1">
              <InputLabel>Landmark</InputLabel>
              <TextField
                placeholder="Locality"
                name="landmark"
                value={formik.values.landmark}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.landmark && formik.errors.landmark
                    ? true
                    : false
                }
                helperText={
                  formik.touched.landmark && formik.errors.landmark
                    ? formik.errors.landmark
                    : null
                }
              />
            </span>
          </span>

          <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
            <span className="flex-column gap-1">
              <InputLabel>City</InputLabel>
              <TextField
                placeholder="e.g - Riyadh "
                name="city"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.city}
                error={formik.touched.city && formik.errors.city ? true : false}
                helperText={
                  formik.touched.city && formik.errors.city
                    ? formik.errors.city
                    : null
                }
              />
            </span>
            <span className="flex-column gap-1">
              <InputLabel>Country</InputLabel>
              <TextField
                placeholder="Country"
                name="country"
                value={formik.values.country}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.country && formik.errors.country ? true : false
                }
                helperText={
                  formik.touched.country && formik.errors.country
                    ? formik.errors.country
                    : null
                }
              />
            </span>
          </span>
          <span className=" user-personal-update-form-name flex-row align-items-center flex-wrap justify-content-between">
            <span className="flex-column gap-1">
              <InputLabel>Address Type</InputLabel>
              <div className="flex-row gap-2">
                <span className="flex-row gap-1 align-items-center">
                  <Checkbox
                    checked={addressType === "home"}
                    onChange={() => {
                      setAddressType("home");
                    }}
                  />
                  <p>Home</p>
                </span>
                <span className="flex-row gap-1 align-items-center">
                  <Checkbox
                    checked={addressType === "office"}
                    onChange={() => {
                      setAddressType("office");
                    }}
                  />
                  <p>Office</p>
                </span>
              </div>
            </span>
          </span>
          <span className="personal-info-save-btn flex-row align-items-center gap-2 ">
            <Button type="submit">Save</Button>
            <Button
              onClick={() => {
                setShowEditSection(false);
              }}
            >
              Cancel
            </Button>
          </span>
        </form>
      ) : (
        <>
          <div className="profile-address-type" ref={editAddressRef}>
            {props?.address?.addressType && (
              <span className="profile-address-type-span">
                {props?.address?.addressType}
              </span>
            )}
            <Button
              className="address-more-tag"
              onClick={() => {
                setEditAddress(!editAddress);
              }}
            >
              <MoreVert />
            </Button>
            {editAddress && (
              <span className=" edit-saved-address ">
                <p
                  onClick={() => {
                    setShowEditSection(true);
                  }}
                >
                  Edit
                </p>
                <p onClick={handleDeleteAddress}>Delete</p>
              </span>
            )}
          </div>
          <div className="profile-saves-address-name flex-row align-items-center gap-2 ">
            <span>
              {" "}
              {props?.address?.firstName + " " + props?.address?.lastName}{" "}
            </span>
            <span> {props?.address?.contactNo} </span>
          </div>
          <div className="profile-saved-address-details flex-row align-items-center gap-1 flex-wrap">
            <span> {props?.address?.landmark} </span>
            <span>{props?.address?.address} </span>
            <span> {props?.address?.city} </span>
            <span> {props?.address?.country} </span>
            <span>{props?.address?.postalCode} </span>
          </div>
        </>
      )}
    </div>
  );
};

export default AddressCard;
